import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { FiltersState } from '../../../model/global'

const initialState: FiltersState = {
	suggestedInput: {
		text: '',
		lat: -1,
		lng: -1,
		zip: '',
	},
	selectedPartnerCategories: [],
	distanceRadiusInKm: 25,
	partnerCategories: [],
	defaultCenter: {
		lat: -1,
		lng: -1,
	}
}

const filtersSlice = createSlice({
	name: 'filtersSlice',
	initialState,
	reducers: {
		setPartnerCategories(state, { payload }: PayloadAction<FiltersState['partnerCategories']>) {
			state.partnerCategories = payload
		},
		setSuggestedInput(state, { payload }: PayloadAction<FiltersState['suggestedInput']>) {
			state.suggestedInput = payload
		},
		setPartnerCategoryType(state, { payload }: PayloadAction<string[]>) {
			state.selectedPartnerCategories = payload
		},
		addPartnerCategoryType(state, { payload }: PayloadAction<string>) {
			state.selectedPartnerCategories.push(payload)
		},
		removePartnerCategoryType(state, { payload }: PayloadAction<string>) {
			state.selectedPartnerCategories.filter(category => category !== payload)
		},
		resetselectedPartnerCategories(state) {
			state.selectedPartnerCategories = []
		},
		setDistanceRadiusInKm(state, { payload }: PayloadAction<FiltersState['distanceRadiusInKm']>) {
			state.distanceRadiusInKm = payload
		},
		setFilters(state, { payload }: PayloadAction<Partial<FiltersState>>) {
			Object.keys(payload).forEach(key => state[key] = payload[key])
			return state
		},
	},
})

export const filtersSliceActions = filtersSlice.actions
export default filtersSlice.reducer
